<ng-template [sbmodal]="'pwchangesuccessmodal'">
  <sb-custom-modal [templateId]="'pwchangesuccessmodal'">
    <div slot="body">
      <div class="d-flex justify-content-center">
        <sb-icon
          style="font-size: 5rem" icon="successAnimation"
          [animationOptions]="{autoplay: true, loop: false}" class="green"></sb-icon>
      </div>
      <div class="mt-4">
        {{'lang.user.passwordchange.successMessage' | translate}}
      </div>
    </div>
    <div slot="footer">
    </div>
  </sb-custom-modal>
</ng-template>
<ng-template [sbmodal]="'pwchangefailedmodal'">
  <sb-custom-modal [templateId]="'pwchangefailedmodal'">
    <div slot="body">
      <div class="d-flex justify-content-center">
        <sb-icon
          style="font-size: 5rem" icon="errorAnimation"
          [animationOptions]="{autoplay: true, loop: false}" class="red"></sb-icon>
      </div>
      <div class="mt-4">
        {{'lang.user.passwordchange.failureMessage' | translate}}
      </div>
    </div>
    <div slot="footer">
    </div>
  </sb-custom-modal>
</ng-template>
<div class="row">
  <div class="col">
    <sb-card [loading]="loading">
      <div card-header>
        <h3>{{'lang.globals.security' | translate}}</h3>
      </div>
      <div card-body>
        <form [formGroup]="form" class="wizard__forms px-5 pb-5">
          <h3 class="mb-4">{{'lang.user.changePassword' | translate}}</h3>
          <div class="row">
            <div class="col-6">
              <div class="form-group validateMe">
                <label class="form-label" for="OldPassword">{{'lang.user.oldPassword' | translate}}</label>
                <input type="password" id="OldPassword" class="form-control"
                       formControlName="OldPassword">
                <span class="form-text text-muted">{{'lang.user.oldPasswordDescription' |
                  translate}}</span>
                <div *ngIf="OldPassword.touched && OldPassword.errors?.required"
                     class="alert alert-danger">
                  {{'lang.user.oldPasswordWarning' | translate}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group validateMe">
                <label class="form-label" for="NewPassword">{{'lang.user.newPassword' | translate}}</label>
                <input type="password" id="NewPassword" class="form-control"
                       formControlName="NewPassword">
                <span class="form-text text-muted">{{'lang.user.newPasswordDescription' |
                  translate}}</span>
                <div *ngIf="NewPassword.touched && NewPassword.errors?.required"
                     class="alert alert-danger">
                  {{'lang.user.newPasswordWarning' | translate}}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group validateMe">
                <label class="form-label" for="NewPasswordRepeat">{{'lang.user.newPasswordRepeat' | translate}}</label>
                <input type="password" id="NewPasswordRepeat" class="form-control"
                       formControlName="NewPasswordRepeat">
                <span class="form-text text-muted">{{'lang.user.newPasswordRepeatDescription' |
                  translate}}</span>
                <div *ngIf="NewPasswordRepeat.touched && NewPasswordRepeat.errors?.required"
                     class="alert alert-danger">
                  {{'lang.user.newPasswordRepeatWarning' | translate}}</div>
                <div
                  *ngIf="NewPasswordRepeat.touched && NewPasswordRepeat.errors?.invalid && !NewPasswordRepeat.errors?.required"
                  class="alert alert-danger">
                  {{'lang.user.newPasswordRepeatMatchWarning' | translate}}</div>
              </div>
            </div>
          </div>
          <hr class="border-dashed">
          <div class="row">
            <div class="col text-end">
              <sb-button [disabled]="formInvalid" (submitClicked)="submit()"
                         classes="btn-success btn-wide btn-lg">{{'lang.globals.submit' | translate}}</sb-button>
            </div>
          </div>
        </form>
      </div>
    </sb-card>
  </div>
</div>
